import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, tap } from 'rxjs';
import { CardActions } from './card.actions';

@Injectable({
  providedIn: 'root'
})
export class CardEffects {
  sendCardEffect$: Observable<Action>;

  constructor(private actions$: Actions) {
    this.sendCardEffect$ = createEffect(
      (): any =>
        this.actions$.pipe(
          ofType(CardActions.submitSuccess),
          tap(() => {})
        ),
      { dispatch: false }
    );
  }
}
